/**
 * On the public host (`launches.wetakeover.xyz/<token>`, or `launch.`) the share token is the first path segment.
 * Returns `undefined` on every other host (the normal app), the token on the public host, and ''
 * for the bare domain, which the page shows as the sales pitch.
 */
export function publicLaunchHostToken(location = window.location) {
  const hostname = String(location?.hostname || '').toLowerCase();
  if (!hostname.startsWith('launches.') && !hostname.startsWith('launch.')) return undefined;
  const segment = String(location?.pathname || '').split('/').filter(Boolean)[0] || '';
  try {
    return decodeURIComponent(segment);
  } catch (error) {
    return '';
  }
}
